import { QuestionBase } from './question-base.model';

export class EditableTableQuestion extends QuestionBase<any> {
    controlType = 'editable-table';
    datasource: any;
    fieldDataSource:any;
    visible: string;
    minWidth: string;
    form: any;
    resource: string;
    dependentField: any;

    constructor(options: {} = {}) {
        super(options);
        this.resource = options['resource'];
        this.datasource = options['datasource'];
        this.fieldDataSource = options['fieldDataSource'];
        this.form = options['form'];
        this.visible = options['visible'] || "true";
        this.minWidth = options['minWidth'] || 'auto';
        this.dependentField = options['dependentField']
    }
}
